<template>
  <div>
    <common-template v-if="!modal">
    <loading :active.sync="load" :loader="'dots'" :color="'#FFF'" :background-color="'#000'" :can-cancel="false" :is-full-page="true"></loading>
      <div class="list">
        <h1
        v-if="!modal"
        class="title d-flex border-bottom inner">{{ $t(pageTitle) }}</h1>
        <div class="table-list inner">
          <h2
          v-if="!modal"
          class="title">{{ $t("会社情報") }}</h2>
          <div class="content">
            <div class="table table-bordered">
              <div class="my-3 d-flex flex-column align-items-center">
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("会社ID") }}
                  </label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.uid"
                      type="text"
                      class="form-control"
                      readonly
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("国") }}
                    <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <select
                      v-model="form.countryCode"
                      class="form-control"
                      id="exampleFormControlSelect1"
                    >
                      <template>
                        <option
                          v-for="(item, index) in country"
                          :key="index"
                          :value="item.code"
                        >{{ $t(item.name) }}</option>
                      </template>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("会社名") }}
                    <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.name"
                      type="text"
                      class="form-control"
                      placeholder="ものレボ株式会社"
                    />
                  </div>
                </div>
                <div v-if="form.countryCode == 'JP'" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("カナ") }}
                  </label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.kana"
                      type="text"
                      class="form-control"
                      placeholder="モノレボカブシキガイシャ"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("郵便番号") }}
                    <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.zipcode"
                      class="form-control"
                      placeholder="604-8206"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ form.countryCode === 'JP' ? $t("都道府県") : $t("州") }}
                    <span
                      class="text-danger"
                    >&nbsp;{{ $t("※必須") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <select v-model="form.prefCode" name="pref" id="id_pref" class="form-control">
                      <option value></option>
                      <template v-if="form.countryCode">
                        <option
                          v-for="(item, index) in pref[form.countryCode]"
                          :key="index"
                          :value="item.code"
                        >{{ $t(item.name) }}</option>
                      </template>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("住所1") }}
                    <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.address1"
                      type="text"
                      class="form-control"
                      placeholder="京都市中京区"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("住所2") }}
                    <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.address2"
                      type="text"
                      class="form-control"
                      placeholder="新町通三条上ル町頭町112"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("住所3") }}</label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.address3"
                      type="text"
                      class="form-control"
                      placeholder="菊三ビル3F"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("TEL") }}
                    <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.phoneNo"
                      type="text"
                      class="form-control"
                      placeholder="075-585-5097"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("FAX") }}</label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.faxNo"
                      type="text"
                      class="form-control"
                      placeholder="075-585-5097"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("Eメール") }}</label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.email"
                      type="text"
                      class="form-control"
                      placeholder="info@mono-revo.co.jp"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("ロゴ画像") }}</label>
                  <div class="col-sm-8">
                    <input class="form-file" type="file" name="logofile" ref="logofile" @change="processlogoFile($event)" />
                    <div class="d-flex mt-2">
                      <template v-if="logoFileData.url || showLogoImage">
                        <div class="form-img">
                          <img :src="logoFileData.url ? logoFileData.url : showLogoImage">
                        </div>
                        <span class="ml-3 form-file-delete">
                          <font-awesome-icon
                            :icon="['fas', 'times-circle']"
                            class="text-danger"
                            @click="deleteLogoFile"
                          />
                        </span>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("印影画像") }}</label>
                  <div class="col-sm-8">
                    <input class="form-file" type="file" name="imprint" ref="signfile" @change="processSignFile($event)" />
                    <div class="d-flex mt-2">
                      <template v-if="signFileData.url || showSignImage">
                        <div class="form-img">
                          <img :src="signFileData.url ? signFileData.url : showSignImage">
                        </div>
                        <span class="ml-3 form-file-delete">
                          <font-awesome-icon
                            :icon="['fas', 'times-circle']"
                            class="text-danger"
                            @click="deleteSignFile"
                          />
                        </span>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group">
                      <date-picker v-model="form.regularStartTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group">
                      <date-picker v-model="form.regularEndTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group">
                      <date-picker v-model="form.displayStartTime" :config="timepicker.options" :disabled="form.isFullWorkTime"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" id="regular_end_time" data-widget="timepicker">
                      <date-picker v-model="form.displayEndTime" :config="timepicker.options" :disabled="form.isFullWorkTime"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label"></label>
                  <div class="col-sm-8">
                    <q-toggle
                      v-model="form.isFullWorkTime"
                      :label="$t('24時間稼動')"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group">
                      <date-picker v-model="form.breakStartTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group">
                      <date-picker v-model="form.breakEndTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("シフトの有無") }}</label>
                  <div class="col-sm-8">
                    <q-toggle
                      v-model="form.isUseShifts"
                      :label="$t('シフト 有')"
                    />
                  </div>
                </div>

                <div v-show="form.isUseShifts" class="form-group row" style="border-bottom:1px solid #ccc">
                  <label for="" class="col-sm-4 col-form-label" style="font-weight:bold">{{ $t("シフト1") }}</label>
                </div>

                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.regularStartTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.regularEndTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.displayStartTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.displayEndTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻①") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.breakStartTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻①") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.breakEndTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻②") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.breakStartTime2" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻②") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.breakEndTime2" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-show="form.isUseShifts" class="form-group row" style="border-bottom:1px solid #ccc">
                  <label for="" class="col-sm-4 col-form-label" style="font-weight:bold">{{ $t("シフト2") }}</label>
                </div>

                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.regularStartTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.regularEndTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.displayStartTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.displayEndTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻①") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.breakStartTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻①") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.breakEndTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻②") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.breakStartTime2" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻②") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.breakEndTime2" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-show="form.isUseShifts" class="form-group row" style="border-bottom:1px solid #ccc">
                  <label for="" class="col-sm-4 col-form-label" style="font-weight:bold">{{ $t("シフト3") }}</label>
                </div>

                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.regularStartTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.regularEndTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.displayStartTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.displayEndTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻①") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.breakStartTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻①") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.breakEndTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻②") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.breakStartTime2" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻②") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.breakEndTime2" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">{{ $t("会社カレンダー") }}</label>
                  <div class="col-sm-8">
                    <button class="btn-content btn-light flex-shrink-1" @click="openCompanyCalendarModal">{{ $t("設定") }}</button>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">
                    <span class="ml-5">{{ $t("カレンダー表示先頭月") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <b-form-select
                      class="form-control"
                      v-model="form.options.calendarDisplayMonth"
                      :options="this.$appConfig.CalendarDisplayMonth"
                      value-field="value"
                      text-field="name"
                    ></b-form-select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">
                    <span class="ml-5">{{ $t("週の始まり") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <b-form-select
                      class="form-control"
                      v-model="form.options.calendarDisplayDayOfWeek"
                      :options="this.$appConfig.CalendarDisplayDayOfWeek"
                      value-field="value"
                      text-field="name"
                    ></b-form-select>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("締日種別") }}
                  </label>
                  <div class="col-sm-8">
                    <div class>
                      <label class for="id_closing_date_type_0">
                        <input
                          type="radio"
                          name="closing_date_type"
                          value="date"
                          id="id_closing_date_type_0"
                          v-model.number="form.closingDayType"
                          required
                          checked
                        />
                        {{ $t("日付") }}
                      </label>
                      <label class="ml-4" for="id_closing_date_type_1">
                        <input
                          type="radio"
                          name="closing_date_type"
                          value="eom"
                          id="id_closing_date_type_1"
                          v-model="form.closingDayType"
                          required
                        />
                        {{ $t("月末") }}
                      </label>
                      <label class="ml-4" for="id_closing_date_type_2">
                        <input
                          type="radio"
                          name="closing_date_type"
                          value="each"
                          v-model="form.closingDayType"
                          id="id_closing_date_type_2"
                          required
                        />
                        {{ $t("都度払い") }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("締日") }}</label>
                  <div class="col-sm-8">
                    <input type="number" v-model.number="form.closingDay" class="form-control input size_w" min="1" max="31" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("支払日種別") }}
                  </label>
                  <div class="col-sm-8">
                    <div class>
                      <label class for="id_payment_date_type_0">
                        <input
                          type="radio"
                          name="payment_date_type"
                          value="dom"
                          id="id_payment_date_type_0"
                          v-model="form.payType"
                          required
                          checked
                        />
                        {{ $t("当月日付") }}
                      </label>
                      <label class="ml-4" for="id_payment_date_type_1">
                        <input
                          type="radio"
                          name="payment_date_type"
                          value="eom"
                          id="id_payment_date_type_1"
                          v-model="form.payType"
                          required
                        />
                        {{ $t("当月末") }}
                      </label>
                      <label class="ml-4" for="id_payment_date_type_2">
                        <input
                          type="radio"
                          name="payment_date_type"
                          value="nmd"
                          id="id_payment_date_type_2"
                          v-model="form.payType"
                          required
                        />
                        {{ $t("翌月日付") }}
                      </label>
                      <label class="ml-4" for="id_payment_date_type_4">
                        <input
                          type="radio"
                          name="payment_date_type"
                          value="eonm"
                          id="id_payment_date_type_4"
                          v-model="form.payType"
                          required
                        />
                        {{ $t("翌月末") }}
                      </label>
                      <label class="ml-4" for="id_payment_date_type_4">
                        <input
                          type="radio"
                          name="payment_date_type"
                          value="each"
                          id="id_payment_date_type_4"
                          v-model="form.payType"
                          required
                        />
                        {{ $t("都度払い") }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("支払日") }}</label>
                  <div class="col-sm-8">
                    <input type="number" v-model.number="form.payDay" class="form-control input size_w" min="1" max="31" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("決算月") }}</label>
                  <div class="col-sm-8">
                    <input type="number" v-model.number="form.closingMonth" class="form-control input size_w" min="1" max="12" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("決算月締日種別") }}</label>
                  <div class="col-sm-8">
                    <div class>
                      <label class for="id_settlement_type_1">
                        <input
                          type="radio"
                          name="settlement_day"
                          value="date"
                          id="id_settlement_type_1"
                          v-model="form.closingDateType"
                          required
                          checked
                        />
                        {{ $t("日付") }}
                      </label>
                      <label class="ml-4" for="id_settlement_type_2">
                        <input
                          type="radio"
                          name="settlement_day"
                          value="eom"
                          id="id_settlement_type_2"
                          v-model="form.closingDateType"
                          required
                        />
                        {{ $t("月末") }}
                      </label>
                      <label class="ml-4" for="id_settlement_type_3">
                        <input
                          type="radio"
                          name="settlement_day"
                          value="each"
                          id="id_settlement_type_3"
                          v-model="form.closingDateType"
                          required
                        />
                        {{ $t("都度払い") }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("決算月締日") }}</label>
                  <div class="col-sm-8">
                    <input type="number" v-model.number="form.closingDate" class="form-control input size_w" min="1" max="31" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("決算直後支払日種別") }}</label>
                  <div class="col-sm-8">
                    <div class>
                      <label class for="id_after_settlement_payment_type_0">
                        <input
                          type="radio"
                          name="after_settlement_payment_type"
                          value="dom"
                          id="id_after_settlement_payment_type_0"
                          v-model="form.closingDatePayType"
                          required
                          checked
                        />
                        {{ $t("当月日付") }}
                      </label>
                      <label class="ml-4" for="id_after_settlement_payment_type_1">
                        <input
                          type="radio"
                          name="after_settlement_payment_type"
                          value="eom"
                          id="id_after_settlement_payment_type_1"
                          v-model="form.closingDatePayType"
                          required
                        />
                        {{ $t("当月末") }}
                      </label>
                      <label class="ml-4" for="id_after_settlement_payment_type_2">
                        <input
                          type="radio"
                          name="after_settlement_payment_type"
                          value="nmd"
                          id="id_after_settlement_payment_type_2"
                          v-model="form.closingDatePayType"
                          required
                        />
                        {{ $t("翌月日付") }}
                      </label>
                      <label class="ml-4" for="id_after_settlement_payment_type_3">
                        <input
                          type="radio"
                          name="after_settlement_payment_type"
                          value="eonm"
                          id="id_after_settlement_payment_type_3"
                          v-model="form.closingDatePayType"
                          required
                        />
                        {{ $t("翌月末") }}
                      </label>
                      <label class="ml-4" for="id_after_settlement_payment_type_4">
                        <input
                          type="radio"
                          name="after_settlement_payment_type"
                          value="each"
                          id="id_after_settlement_payment_type_4"
                          v-model="form.closingDatePayType"
                          required
                        />
                        {{ $t("都度払い") }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("決算直後支払日") }}</label>
                  <div class="col-sm-8">
                    <input type="number" v-model.number="form.closingDatePayDay" class="form-control input size_w"  min="1" max="31" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("支払い方法") }}
                  </label>
                  <div class="col-sm-8">
                    <div class>
                      <label class for="id_pay_method_0">
                        <input
                          type="radio"
                          name="pay_method"
                          value="cash"
                          id="id_pay_method_0"
                          v-model="form.payMethod"
                          required
                          checked
                        />
                        {{ $t("現金") }}
                      </label>
                      <label class="ml-4" for="id_pay_method_1">
                        <input type="radio" name="pay_method" value="transfer" id="id_pay_method_1"
                          v-model="form.payMethod" required />
                        {{ $t("振込") }}
                      </label>
                      <label class="ml-4" for="id_pay_method_2">
                        <input type="radio" name="pay_method" value="bill" id="id_pay_method_2"
                          v-model="form.payMethod" required />
                        {{ $t("手形") }}
                      </label>
                      <label class="ml-4" for="id_pay_method_3">
                        <input type="radio" name="pay_method" value="check" id="id_pay_method_3"
                          v-model="form.payMethod" required />
                        {{ $t("小切手") }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("税計算法") }}
                  </label>
                  <div class="col-sm-8">
                    <div class>
                      <label class for="id_tax_calc_0">
                        <input
                          type="radio"
                          name="tax_calc"
                          value="round"
                          id="id_tax_calc_0"
                          v-model="form.taxCalc"
                          required
                          checked
                        />
                        {{ $t("四捨五入") }}
                      </label>
                      <label class="ml-4" for="id_tax_calc_1">
                        <input type="radio" name="tax_calc" value="ceil" id="id_tax_calc_1"
                          v-model="form.taxCalc" required />
                        {{ $t("切り上げ") }}
                      </label>
                      <label class="ml-4" for="id_tax_calc_2">
                        <input type="radio" name="tax_calc" value="floor" id="id_tax_calc_2"
                          v-model="form.taxCalc" required />
                        {{ $t("切り捨て") }}
                      </label>
                      <label class="ml-4" for="id_tax_calc_3">
                        <input type="radio" name="tax_calc" value="include" id="id_tax_calc_3"
                          v-model="form.taxCalc" required />
                        {{ $t("税込") }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("税率") }}</label>
                  <div class="col-sm-8">
                    <input type="number" v-model.number="form.tax" class="form-control input size_w" min="0" step="any" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("表示桁数") }}</label>
                  <div class="col-sm-8">
                    <input type="number" v-model.number="form.digits" class="form-control input size_w" min="0" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("payee", {index: 1}) }}</label>
                  <div class="col-sm-8">
                    <input type="text" v-model.number="form.payee1" class="form-control input size_w" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("payee", {index: 2}) }}</label>
                  <div class="col-sm-8">
                    <input type="text" v-model.number="form.payee2" class="form-control input size_w" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("payee", {index: 3}) }}</label>
                  <div class="col-sm-8">
                    <input type="text" v-model.number="form.payee3" class="form-control input size_w" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("payee", {index: 4}) }}</label>
                  <div class="col-sm-8">
                    <input type="text" v-model.number="form.payee4" class="form-control input size_w" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("payee", {index: 5}) }}</label>
                  <div class="col-sm-8">
                    <input type="text" v-model.number="form.payee5" class="form-control input size_w" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-column">
              <p class="text-danger text-center" v-if="error">{{ error }}</p>
              <div class="d-flex justify-content-center mt-4 mb-4">
                <button
                  type="button"
                  class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
                  @click="editCompany()"
                  :disabled="editable"
                >
                  <div
                    class="d-flex justify-content-center align-items-center mr-3"
                    v-if="editable"
                  >
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </div>
                  {{ $t("登録") }}
                </button>
                <button
                  type="button"
                  class="btn btn-light"
                  @click="modalClose()"
                  :disabled="editable"
                >{{ $t("キャンセル") }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <company-calendar-modal
        ref="companyCalendarModal"
        :title="$t('会社カレンダー登録')"
        :holidays="form.holidays"
        @register="registerCompanyCalendarModal"
        :displayMonth="form.options.calendarDisplayMonth"
        :displayDayOfWeek="form.options.calendarDisplayDayOfWeek"
        :countryCode="form.countryCode"
      ></company-calendar-modal>
    </common-template>
    <div v-if="modal">
    <loading :active.sync="load" :loader="'dots'" :color="'#FFF'" :background-color="'#000'" :can-cancel="false" :is-full-page="true"></loading>
    <div class="container-fluid">
      <div class="list">
        <h1
        v-if="!modal"
        class="title d-flex border-bottom inner">{{ $t(pageTitle) }}</h1>
        <div class="table-list inner">
          <h2
          v-if="!modal"
          class="title">{{ $t("会社情報") }}</h2>
          <div class="content">
            <div class="table table-bordered">
              <div class="my-3 d-flex flex-column align-items-center">
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("会社ID") }}
                  </label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.uid"
                      type="text"
                      class="form-control"
                      readonly
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("国") }}
                    <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <select
                      v-model="form.countryCode"
                      class="form-control"
                      id="exampleFormControlSelect1"
                    >
                      <template>
                        <option
                          v-for="(item, index) in country"
                          :key="index"
                          :value="item.code"
                        >{{ $t(item.name) }}</option>
                      </template>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("会社名") }}
                    <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.name"
                      type="text"
                      class="form-control"
                      placeholder="ものレボ株式会社"
                    />
                  </div>
                </div>
                <div v-if="form.countryCode == 'JP'" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("カナ") }}
                  </label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.kana"
                      type="text"
                      class="form-control"
                      placeholder="モノレボカブシキガイシャ"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("郵便番号") }}
                    <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.zipcode"
                      class="form-control"
                      placeholder="604-8206"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ form.countryCode === 'JP' ? $t("都道府県") : $t("州") }}
                    <span
                      class="text-danger"
                    >&nbsp;{{ $t("※必須") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <select v-model="form.prefCode" name="pref" id="id_pref" class="form-control">
                      <option value></option>
                      <template v-if="form.countryCode">
                        <option
                          v-for="(item, index) in pref[form.countryCode]"
                          :key="index"
                          :value="item.code"
                        >{{ $t(item.name) }}</option>
                      </template>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("住所1") }}
                    <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.address1"
                      type="text"
                      class="form-control"
                      placeholder="京都市中京区"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("住所2") }}
                    <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.address2"
                      type="text"
                      class="form-control"
                      placeholder="新町通三条上ル町頭町112"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("住所3") }}</label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.address3"
                      type="text"
                      class="form-control"
                      placeholder="菊三ビル3F"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("TEL") }}
                    <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.phoneNo"
                      type="text"
                      class="form-control"
                      placeholder="075-585-5097"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("FAX") }}</label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.faxNo"
                      type="text"
                      class="form-control"
                      placeholder="075-585-5097"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("Eメール") }}</label>
                  <div class="col-sm-8">
                    <input
                      v-model="form.email"
                      type="text"
                      class="form-control"
                      placeholder="info@mono-revo.co.jp"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("ロゴ画像") }}</label>
                  <div class="col-sm-8">
                    <input class="form-file" type="file" name="logofile" ref="logofile" @change="processlogoFile($event)" />
                    <div class="d-flex mt-2">
                      <template v-if="logoFileData.url || showLogoImage">
                        <div class="form-img">
                          <img :src="logoFileData.url ? logoFileData.url : showLogoImage">
                        </div>
                        <span class="ml-3 form-file-delete">
                          <font-awesome-icon
                            :icon="['fas', 'times-circle']"
                            class="text-danger"
                            @click="deleteLogoFile"
                          />
                        </span>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("印影画像") }}</label>
                  <div class="col-sm-8">
                    <input class="form-file" type="file" name="imprint" ref="signfile" @change="processSignFile($event)" />
                    <div class="d-flex mt-2">
                      <template v-if="signFileData.url || showSignImage">
                        <div class="form-img">
                          <img :src="signFileData.url ? signFileData.url : showSignImage">
                        </div>
                        <span class="ml-3 form-file-delete">
                          <font-awesome-icon
                            :icon="['fas', 'times-circle']"
                            class="text-danger"
                            @click="deleteSignFile"
                          />
                        </span>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group">
                      <date-picker v-model="form.regularStartTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group">
                      <date-picker v-model="form.regularEndTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group">
                      <date-picker v-model="form.displayStartTime" :config="timepicker.options" :disabled="form.isFullWorkTime"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" id="regular_end_time" data-widget="timepicker">
                      <date-picker v-model="form.displayEndTime" :config="timepicker.options" :disabled="form.isFullWorkTime"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label"></label>
                  <div class="col-sm-8">
                    <q-toggle
                      v-model="form.isFullWorkTime"
                      :label="$t('24時間稼動')"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group">
                      <date-picker v-model="form.breakStartTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group">
                      <date-picker v-model="form.breakEndTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("シフトの有無") }}</label>
                  <div class="col-sm-8">
                    <q-toggle
                      v-model="form.isUseShifts"
                      :label="$t('シフト 有')"
                    />
                  </div>
                </div>

                <div v-show="form.isUseShifts" class="form-group row" style="border-bottom:1px solid #ccc">
                  <label for="" class="col-sm-4 col-form-label" style="font-weight:bold">{{ $t("シフト1") }}</label>
                </div>

                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.regularStartTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.regularEndTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.displayStartTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.displayEndTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻①") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.breakStartTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻①") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.breakEndTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻②") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.breakStartTime2" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻②") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime1.breakEndTime2" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-show="form.isUseShifts" class="form-group row" style="border-bottom:1px solid #ccc">
                  <label for="" class="col-sm-4 col-form-label" style="font-weight:bold">{{ $t("シフト2") }}</label>
                </div>

                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.regularStartTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.regularEndTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.displayStartTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.displayEndTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻①") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.breakStartTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻①") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.breakEndTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻②") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.breakStartTime2" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻②") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime2.breakEndTime2" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-show="form.isUseShifts" class="form-group row" style="border-bottom:1px solid #ccc">
                  <label for="" class="col-sm-4 col-form-label" style="font-weight:bold">{{ $t("シフト3") }}</label>
                </div>

                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.regularStartTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("定時終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.regularEndTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働開始時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.displayStartTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("稼働終了時刻") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.displayEndTime" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻①") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.breakStartTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻①") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.breakEndTime1" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻②") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.breakStartTime2" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="form.isUseShifts" class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻②") }}</label>
                  <div class="col-sm-8">
                    <div class="input-group" data-widget="timepicker">
                      <date-picker v-model="form.workTime3.breakEndTime2" :config="timepicker.options"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'clock']" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">{{ $t("会社カレンダー") }}</label>
                  <div class="col-sm-8">
                    <button class="btn-content btn-light flex-shrink-1" @click="openCompanyCalendarModal">{{ $t("設定") }}</button>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">
                    <span class="ml-5">{{ $t("カレンダー表示先頭月") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <b-form-select
                      class="form-control"
                      v-model="form.options.calendarDisplayMonth"
                      :options="this.$appConfig.CalendarDisplayMonth"
                      value-field="value"
                      text-field="name"
                    ></b-form-select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">
                    <span class="ml-5">{{ $t("週の始まり") }}</span>
                  </label>
                  <div class="col-sm-8">
                    <b-form-select
                      class="form-control"
                      v-model="form.options.calendarDisplayDayOfWeek"
                      :options="this.$appConfig.CalendarDisplayDayOfWeek"
                      value-field="value"
                      text-field="name"
                    ></b-form-select>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("締日種別") }}
                  </label>
                  <div class="col-sm-8">
                    <div class>
                      <label class for="id_closing_date_type_0">
                        <input
                          type="radio"
                          name="closing_date_type"
                          value="date"
                          id="id_closing_date_type_0"
                          v-model.number="form.closingDayType"
                          required
                          checked
                        />
                        {{ $t("日付") }}
                      </label>
                      <label class="ml-4" for="id_closing_date_type_1">
                        <input
                          type="radio"
                          name="closing_date_type"
                          value="eom"
                          id="id_closing_date_type_1"
                          v-model="form.closingDayType"
                          required
                        />
                        {{ $t("月末") }}
                      </label>
                      <label class="ml-4" for="id_closing_date_type_2">
                        <input
                          type="radio"
                          name="closing_date_type"
                          value="each"
                          v-model="form.closingDayType"
                          id="id_closing_date_type_2"
                          required
                        />
                        {{ $t("都度払い") }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("締日") }}</label>
                  <div class="col-sm-8">
                    <input type="number" v-model.number="form.closingDay" class="form-control input size_w" min="1" max="31" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("支払日種別") }}
                  </label>
                  <div class="col-sm-8">
                    <div class>
                      <label class for="id_payment_date_type_0">
                        <input
                          type="radio"
                          name="payment_date_type"
                          value="dom"
                          id="id_payment_date_type_0"
                          v-model="form.payType"
                          required
                          checked
                        />
                        {{ $t("当月日付") }}
                      </label>
                      <label class="ml-4" for="id_payment_date_type_1">
                        <input
                          type="radio"
                          name="payment_date_type"
                          value="eom"
                          id="id_payment_date_type_1"
                          v-model="form.payType"
                          required
                        />
                        {{ $t("当月末") }}
                      </label>
                      <label class="ml-4" for="id_payment_date_type_2">
                        <input
                          type="radio"
                          name="payment_date_type"
                          value="nmd"
                          id="id_payment_date_type_2"
                          v-model="form.payType"
                          required
                        />
                        {{ $t("翌月日付") }}
                      </label>
                      <label class="ml-4" for="id_payment_date_type_4">
                        <input
                          type="radio"
                          name="payment_date_type"
                          value="eonm"
                          id="id_payment_date_type_4"
                          v-model="form.payType"
                          required
                        />
                        {{ $t("翌月末") }}
                      </label>
                      <label class="ml-4" for="id_payment_date_type_4">
                        <input
                          type="radio"
                          name="payment_date_type"
                          value="each"
                          id="id_payment_date_type_4"
                          v-model="form.payType"
                          required
                        />
                        {{ $t("都度払い") }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("支払日") }}</label>
                  <div class="col-sm-8">
                    <input type="number" v-model.number="form.payDay" class="form-control input size_w" min="1" max="31" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("決算月") }}</label>
                  <div class="col-sm-8">
                    <input type="number" v-model.number="form.closingMonth" class="form-control input size_w" min="1" max="12" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("決算月締日種別") }}</label>
                  <div class="col-sm-8">
                    <div class>
                      <label class for="id_settlement_type_1">
                        <input
                          type="radio"
                          name="settlement_day"
                          value="date"
                          id="id_settlement_type_1"
                          v-model="form.closingDateType"
                          required
                          checked
                        />
                        {{ $t("日付") }}
                      </label>
                      <label class="ml-4" for="id_settlement_type_2">
                        <input
                          type="radio"
                          name="settlement_day"
                          value="eom"
                          id="id_settlement_type_2"
                          v-model="form.closingDateType"
                          required
                        />
                        {{ $t("月末") }}
                      </label>
                      <label class="ml-4" for="id_settlement_type_3">
                        <input
                          type="radio"
                          name="settlement_day"
                          value="each"
                          id="id_settlement_type_3"
                          v-model="form.closingDateType"
                          required
                        />
                        {{ $t("都度払い") }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("決算月締日") }}</label>
                  <div class="col-sm-8">
                    <input type="number" v-model.number="form.closingDate" class="form-control input size_w" min="1" max="31" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("決算直後支払日種別") }}</label>
                  <div class="col-sm-8">
                    <div class>
                      <label class for="id_after_settlement_payment_type_0">
                        <input
                          type="radio"
                          name="after_settlement_payment_type"
                          value="dom"
                          id="id_after_settlement_payment_type_0"
                          v-model="form.closingDatePayType"
                          required
                          checked
                        />
                        {{ $t("当月日付") }}
                      </label>
                      <label class="ml-4" for="id_after_settlement_payment_type_1">
                        <input
                          type="radio"
                          name="after_settlement_payment_type"
                          value="eom"
                          id="id_after_settlement_payment_type_1"
                          v-model="form.closingDatePayType"
                          required
                        />
                        {{ $t("当月末") }}
                      </label>
                      <label class="ml-4" for="id_after_settlement_payment_type_2">
                        <input
                          type="radio"
                          name="after_settlement_payment_type"
                          value="nmd"
                          id="id_after_settlement_payment_type_2"
                          v-model="form.closingDatePayType"
                          required
                        />
                        {{ $t("翌月日付") }}
                      </label>
                      <label class="ml-4" for="id_after_settlement_payment_type_3">
                        <input
                          type="radio"
                          name="after_settlement_payment_type"
                          value="eonm"
                          id="id_after_settlement_payment_type_3"
                          v-model="form.closingDatePayType"
                          required
                        />
                        {{ $t("翌月末") }}
                      </label>
                      <label class="ml-4" for="id_after_settlement_payment_type_4">
                        <input
                          type="radio"
                          name="after_settlement_payment_type"
                          value="each"
                          id="id_after_settlement_payment_type_4"
                          v-model="form.closingDatePayType"
                          required
                        />
                        {{ $t("都度払い") }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("決算直後支払日") }}</label>
                  <div class="col-sm-8">
                    <input type="number" v-model.number="form.closingDatePayDay" class="form-control input size_w"  min="1" max="31" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("支払い方法") }}
                  </label>
                  <div class="col-sm-8">
                    <div class>
                      <label class for="id_pay_method_0">
                        <input
                          type="radio"
                          name="pay_method"
                          value="cash"
                          id="id_pay_method_0"
                          v-model="form.payMethod"
                          required
                          checked
                        />
                        {{ $t("現金") }}
                      </label>
                      <label class="ml-4" for="id_pay_method_1">
                        <input type="radio" name="pay_method" value="transfer" id="id_pay_method_1"
                          v-model="form.payMethod" required />
                        {{ $t("振込") }}
                      </label>
                      <label class="ml-4" for="id_pay_method_2">
                        <input type="radio" name="pay_method" value="bill" id="id_pay_method_2"
                          v-model="form.payMethod" required />
                        {{ $t("手形") }}
                      </label>
                      <label class="ml-4" for="id_pay_method_3">
                        <input type="radio" name="pay_method" value="check" id="id_pay_method_3"
                          v-model="form.payMethod" required />
                        {{ $t("小切手") }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("税計算法") }}
                  </label>
                  <div class="col-sm-8">
                    <div class>
                      <label class for="id_tax_calc_0">
                        <input
                          type="radio"
                          name="tax_calc"
                          value="round"
                          id="id_tax_calc_0"
                          v-model="form.taxCalc"
                          required
                          checked
                        />
                        {{ $t("四捨五入") }}
                      </label>
                      <label class="ml-4" for="id_tax_calc_1">
                        <input type="radio" name="tax_calc" value="ceil" id="id_tax_calc_1"
                          v-model="form.taxCalc" required />
                        {{ $t("切り上げ") }}
                      </label>
                      <label class="ml-4" for="id_tax_calc_2">
                        <input type="radio" name="tax_calc" value="floor" id="id_tax_calc_2"
                          v-model="form.taxCalc" required />
                        {{ $t("切り捨て") }}
                      </label>
                      <label class="ml-4" for="id_tax_calc_3">
                        <input type="radio" name="tax_calc" value="include" id="id_tax_calc_3"
                          v-model="form.taxCalc" required />
                        {{ $t("税込") }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("税率") }}</label>
                  <div class="col-sm-8">
                    <input type="number" v-model.number="form.tax" class="form-control input size_w" min="0" step="any" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("表示桁数") }}</label>
                  <div class="col-sm-8">
                    <input type="number" v-model.number="form.digits" class="form-control input size_w" min="0" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("payee", {index: 1}) }}</label>
                  <div class="col-sm-8">
                    <input type="text" v-model.number="form.payee1" class="form-control input size_w" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("payee", {index: 2}) }}</label>
                  <div class="col-sm-8">
                    <input type="text" v-model.number="form.payee2" class="form-control input size_w" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("payee", {index: 3}) }}</label>
                  <div class="col-sm-8">
                    <input type="text" v-model.number="form.payee3" class="form-control input size_w" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("payee", {index: 4}) }}</label>
                  <div class="col-sm-8">
                    <input type="text" v-model.number="form.payee4" class="form-control input size_w" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">{{ $t("payee", {index: 5}) }}</label>
                  <div class="col-sm-8">
                    <input type="text" v-model.number="form.payee5" class="form-control input size_w" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-column">
              <p class="text-danger text-center" v-if="error">{{ error }}</p>
              <div class="d-flex justify-content-center mt-4 mb-4">
                <button
                  type="button"
                  class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
                  @click="editCompany()"
                  :disabled="editable"
                >
                  <div
                    class="d-flex justify-content-center align-items-center mr-3"
                    v-if="editable"
                  >
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </div>
                  {{ $t("登録") }}
                </button>
                <button
                  type="button"
                  class="btn btn-light"
                  @click="modalClose()"
                  :disabled="editable"
                >{{ $t("キャンセル") }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <company-calendar-modal
        ref="companyCalendarModal"
        :title="$t('会社カレンダー登録')"
        :holidays="form.holidays"
        @register="registerCompanyCalendarModal"
        :displayMonth="form.options.calendarDisplayMonth"
        :displayDayOfWeek="form.options.calendarDisplayDayOfWeek"
        :countryCode="form.countryCode"
      ></company-calendar-modal>
    </div>
  </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import country from '../../assets/json/country.json'
import pref from '../../assets/json/pref.json'
import thailand from '../../assets/json/raw_database.json'
import CompanyCalendarModal from '../../components/CompanyCalendarModal.vue'
import config from '../../config'

const defaultOptions = {
  calendarDisplayMonth: config.CalendarDisplayMonth[config.CalendarDisplayMonthDefaultIndex].value,
  calendarDisplayDayOfWeek: config.CalendarDisplayDayOfWeek[config.CalendarDisplayDayOfWeekDefaultIndex].value,
}

export default {
  components: {
    CompanyCalendarModal,
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    company: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      pref: pref,
      allDay: false,
      country: country,
      form: {
        uid: '',
        name: '',
        kana: '',
        countryCode: '',
        zipcode: '',
        prefCode: '',
        address1: '',
        address2: '',
        address3: '',
        phoneNo: '',
        faxNo: '',
        email: '',
        logoImage: '',
        signImage: '',

        closingDayType: '',
        closingDay: '',
        payType: '',
        payDay: '',
        closingMonth: '',
        closingDateType: '',
        closingDate: '',
        closingDatePayType: '',
        closingDatePayDay: '',
        payMethod: '',
        taxCalc: '',
        tax: 10,
        digits: 0,
        isUseShifts: false,
        isFullWorkTime: false,
        regularStartTime: '', // 定時開始時刻
        regularEndTime: '', // 定時終了時刻
        displayStartTime: '', // 稼働開始時刻
        displayEndTime: '', // 稼働終了時刻
        breakStartTime1: '', // 休憩開始時刻
        breakEndTime1: '', // 休憩終了時刻
        breakStartTime2: '', // 休憩開始時刻
        breakEndTime2: '', // 休憩終了時刻
        workTime1: {
          regularStartTime: '',
          regularEndTime: '',
          displayStartTime: '',
          displayEndTime: '',
          breakStartTime1: '',
          breakEndTime1: '',
          breakStartTime2: '',
          breakEndTime2: '',
        },
        workTime2: {
          regularStartTime: '',
          regularEndTime: '',
          displayStartTime: '',
          displayEndTime: '',
          breakStartTime1: '',
          breakEndTime1: '',
          breakStartTime2: '',
          breakEndTime2: '',
        },
        workTime3: {
          regularStartTime: '',
          regularEndTime: '',
          displayStartTime: '',
          displayEndTime: '',
          breakStartTime1: '',
          breakEndTime1: '',
          breakStartTime2: '',
          breakEndTime2: '',
        },
        options: _.cloneDeep(defaultOptions),
        holidays: null,
        payee1: '',
        payee2: '',
        payee3: '',
        payee4: '',
        payee5: '',
      },
      logoFileData: {
        url: '',
        data: '',
      },
      signFileData: {
        url: '',
        data: '',
      },
      showLogoImage: '',
      showSignImage: '',
      isDeleteLogoFile: false,
      isDeleteSignFile: false,
      load: false,
      isFormLoading: true,
      editable: false,
      error: '',
      pageTitle: '会社情報登録',
    }
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    if (!this.modal) {
      this.load = true
      try {
        await this.$store.dispatch('auth/user')
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    }
    await this.getCompany(this.company)
  },
  methods: {
    async _getCompany(item = null) {
      let res = {}
      if (!item) {
        res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/company`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
      } else {
        res.data = item
      }

      if (_.isEmpty(res.data.workTime1)) {
        res.data.workTime1 = {
          regularStartTime: '',
          regularEndTime: '',
          displayStartTime: '',
          displayEndTime: '',
          breakStartTime1: '',
          breakEndTime1: '',
          breakStartTime2: '',
          breakEndTime2: '',
        }
      }
      if (_.isEmpty(res.data.workTime2)) {
        res.data.workTime2 = {
          regularStartTime: '',
          regularEndTime: '',
          displayStartTime: '',
          displayEndTime: '',
          breakStartTime1: '',
          breakEndTime1: '',
          breakStartTime2: '',
          breakEndTime2: '',
        }
      }
      if (_.isEmpty(res.data.workTime3)) {
        res.data.workTime3 = {
          regularStartTime: '',
          regularEndTime: '',
          displayStartTime: '',
          displayEndTime: '',
          breakStartTime1: '',
          breakEndTime1: '',
          breakStartTime2: '',
          breakEndTime2: '',
        }
      }
      if (res.data.options === null) {
        res.data.options = _.cloneDeep(defaultOptions)
      } else {
        Object.keys(defaultOptions).forEach(key => {
          if (!res.data.options.hasOwnProperty(key)) {
            res.data.options[key] = _.cloneDeep(defaultOptions[key])
          }
        })
      }

      return res.data
    },
    async getCompany(item = null) {
      this.load = true
      try {
        this.form = await this._getCompany(item)

        if (!this.form.zipcode) this.isFormLoading = false
        // 画像データ取得
        const imagekeys = []
        if (this.form.signImage) {
          imagekeys.push(this.form.signImage)
        }
        if (this.form.logoImage) {
          imagekeys.push(this.form.logoImage)
        }
        if (imagekeys.length) {
          const images = await this.$axios.post(
            `${this.$appConfig.CommonApiUrl}/s3/urls`,
            {'targets': [...imagekeys] },
            {
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
            }
          )
          const target = images.data
          if (target.hasOwnProperty(this.form.signImage)) {
            this.showSignImage = target[this.form.signImage]
          }
          if (target.hasOwnProperty(this.form.logoImage)) {
            this.showLogoImage = target[this.form.logoImage]
          }
        }

        if (!this.form.closingDayType) {
          this.form.closingDayType = 'eom'
        }
        if (!this.form.payType) {
          this.form.payType = 'eom'
        }
        if (!this.form.closingDateType) {
          this.form.closingDateType = 'eom'
        }
        if (!this.form.closingDatePayType) {
          this.form.closingDatePayType = 'eom'
        }
        if (!this.form.payMethod) {
          this.form.payMethod = 'cash'
        }
        if (!this.form.taxCalc) {
          this.form.taxCalc = 'round'
        }
        if (!this.form.tax) {
          this.form.tax = 10
        }
        if (!this.form.digits) {
          this.form.digits = 0
        }
        if (this.form.payee1 === null) {
          this.form.payee1 = ''
        }
        if (this.form.payee2 === null) {
          this.form.payee2 = ''
        }
        if (this.form.payee3 === null) {
          this.form.payee3 = ''
        }
        if (this.form.payee4 === null) {
          this.form.payee4 = ''
        }
        if (this.form.payee5 === null) {
          this.form.payee5 = ''
        }
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
      this.load = false
    },
    _editCompany(data) {
      // 会社登録のパラメーターを定義
      const params = {}
      const unusedFiledNames = ['privilege',
        'isUseInventory',
        'isUseSmallLot',
        'isUsePurchase',
        'couponId',
        'isTrial',
        'autoContractUpdate',
        'coupon',
        'expiredAt',
        'privileges',
        'workTimeId1',
        'workTimeId2',
        'workTimeId3',
        'uid',
        'projectKind',
      ]
      for (const key in data) {
        const invalidFieldName = !data.hasOwnProperty(key) || unusedFiledNames.includes(key)
        if (invalidFieldName) continue

        if (key === 'isFullWorkTime' || key === 'isUseShifts') {
          params[`${key}`] = data[key]
        } else if (key === 'workTime1' || key === 'workTime2' || key === 'workTime3') {
          params[`${key}`] = {
            breakEndTime1: data[key].breakEndTime1 || '',
            breakEndTime2: data[key].breakEndTime2 || '',
            breakStartTime1: data[key].breakStartTime1 || '',
            breakStartTime2: data[key].breakStartTime2 || '',
            displayEndTime: data[key].displayEndTime || '',
            displayStartTime: data[key].displayStartTime || '',
            regularEndTime: data[key].regularEndTime || '',
            regularStartTime: data[key].regularStartTime || '',
          }
        } else if (key === 'digits') {
          if (data[key] !== '') params[`${key}`] = data[key]
        } else if (['holidays', 'options'].indexOf(key) !== -1) {
          if (data[key] !== null) params[`${key}`] = data[key]
        } else if (key === 'tax') {
          if (data[key] !== '') params[`${key}`] = data[key]
        } else {
          if (typeof data[key] === typeof 1) {
            params[`${key}`] = data[key] ? data[key] : null
          } else {
            params[`${key}`] = data[key] ? data[key] : ''
          }
        }
      }

      return this.$axios.put(
        `${this.$appConfig.CommonApiUrl}/company`,
        params,
        {
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
        }
      )
    },
    async editCompany() {
      const pwd = this.form
      this.error = ''
      if (!pwd.countryCode) {
        this.error = this.$t('国') + this.$t('必須メッセージ')
        return
      } else if (!pwd.name) {
        this.error = this.$t('会社名') + this.$t('必須メッセージ')
        return
      } else if (pwd.kana) {
        if (!this.isKana(pwd.kana)) {
          this.error = this.$t('カナの入力が正しくありません')
          return
        }
      } else if (!pwd.zipcode) {
        this.error = this.$t('郵便番号') + this.$t('必須メッセージ')
        return
      } else if (!this.isZipcode(pwd.zipcode)) {
        this.error = this.$t('郵便番号は数字を入力して下さい')
        return
      } else if (!pwd.prefCode) {
        this.error = this.$t('都道府県') + this.$t('必須メッセージ')
        return
      } else if (!pwd.address1) {
        this.error = this.$t('住所1') + this.$t('必須メッセージ')
        return
      } else if (!pwd.address2) {
        this.error = this.$t('住所2') + this.$t('必須メッセージ')
        return
      } else if (!pwd.phoneNo) {
        this.error = this.$t('TEL') + this.$t('必須メッセージ')
        return
      } else if (!this.isTel(pwd.phoneNo)) {
        this.error = this.$t('TELは半角数字と-と+と()のみで入力して下さい')
        return
      }
      this.editable = true
      if (this.isDeleteLogoFile) this.form.logoImage = ''
      if (this.isDeleteSignFile) this.form.signImage = ''

      // ファイルアップロード
      await this.addfiles()

      try {
        await this._editCompany(this.form)
        if (this.modal) this.$emit('registered')
        this.$toasted.success(this.$t('データ登録完了メッセージ'))

        if (!this.modal) window.location.href = this.$appConfig.ScreenUrl.settingMenu
      } catch (err) {
        console.log(err)
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }

      this.editable = false
    },
    processlogoFile(event) {
      this.isDeleteLogoFile = false
      this.logoFileData.data = event.target.files[0]
      this.logoFileData.url = window.URL.createObjectURL(event.target.files[0])
    },
    processSignFile(event) {
      this.isDeleteSignFile = false
      this.signFileData.data = event.target.files[0]
      this.signFileData.url = window.URL.createObjectURL(event.target.files[0])
    },
    deleteLogoFile() {
      this.isDeleteLogoFile = true
      this.showLogoImage = ''
      this.$refs.logofile.value = ''
      this.logoFileData = {
        url: '',
        data: '',
      }
    },
    deleteSignFile() {
      this.isDeleteSignFile = true
      this.showSignImage = ''
      this.$refs.signfile.value = ''
      this.signFileData = {
        url: '',
        data: '',
      }
    },
    // モーダルが開いた処理
    modalOpen(item = null) {
      this.getCompany(item)
    },
    // モーダルの閉じる処理
    modalClose() {
      location.href = this.$appConfig.ScreenUrl.settingMenu
      this.$emit('modal-close')
    },
    // 値の初期化
    valueInit() {
      this.allDay = false,
      this.form = {
        name: '',
        kana: '',
        countryCode: '',
        zipcode: '',
        prefCode: '',
        address1: '',
        address2: '',
        address3: '',
        phoneNo: '',
        faxNo: '',
        logoImage: '',
        signImage: '',

        closingDayType: '',
        closingDay: '',
        payType: '',
        payDay: '',
        closingMonth: '',
        closingDateType: '',
        closingDate: '',
        closingDatePayType: '',
        closingDatePayDay: '',
        payMethod: '',
        taxCalc: '',
        tax: 0,
        digits: 0,
        isFullWorkTime: false,
        regularStartTime: '', // 定時開始時刻
        regularEndTime: '', // 定時終了時刻
        isUseShifts: false, // シフト有無
        displayStartTime: '', // 稼働開始時刻
        displayEndTime: '', // 稼働終了時刻
        breakStartTime1: '', // 休憩開始時刻
        breakEndTime1: '', // 休憩終了時刻
        breakStartTime2: '', // 休憩開始時刻
        breakEndTime2: '', // 休憩終了時刻
        workTime1: {
          regularStartTime: '',
          regularEndTime: '',
          displayStartTime: '',
          displayEndTime: '',
          breakStartTime1: '',
          breakEndTime1: '',
          breakStartTime2: '',
          breakEndTime2: '',
        },
        workTime2: {
          regularStartTime: '',
          regularEndTime: '',
          displayStartTime: '',
          displayEndTime: '',
          breakStartTime1: '',
          breakEndTime1: '',
          breakStartTime2: '',
          breakEndTime2: '',
        },
        workTime3: {
          regularStartTime: '',
          regularEndTime: '',
          displayStartTime: '',
          displayEndTime: '',
          breakStartTime1: '',
          breakEndTime1: '',
          breakStartTime2: '',
          breakEndTime2: '',
        },
      }
      this.logoFileData = {
        url: '',
        data: '',
      }
      this.signFileData = {
        url: '',
        data: '',
      }
      this.showLogoImage = ''
      this.showSignImage = ''
      this.load = false
      this.isFormLoading = true
      this.editable = false
      this.error = ''
    },
    // ファイル追加処理
    async addfiles() {
      return new Promise((resolve) => {
        let files = {}
        if (this.logoFileData.data) files['logoFileData'] = this.logoFileData
        if (this.signFileData.data) files['signFileData'] = this.signFileData
        if (files.logoFileData || files.signFileData) {
          for (let fileKey in files) {
            this.$store.dispatch('file/put', {
              file: files[fileKey].data,
              folder: 'company',
            }).then(data => {
              const key = data.key
              if (key) {
                if (fileKey == 'logoFileData') {
                  // this.form.logoImage = `${this.$appConfig.BucketHost}${key}`
                  this.form.logoImage = `public/${key}`
                } else {
                  // this.form.signImage = `${this.$appConfig.BucketHost}${key}`
                  this.form.signImage = `public/${key}`
                }
                delete files[fileKey]
                if (!Object.keys(files).length) {
                  resolve()
                }
              }
            })
          }
        } else {
          resolve()
        }
      })
    },
    openCompanyCalendarModal() {
      this.$refs.companyCalendarModal.openModal()
    },
    async registerCompanyCalendarModal(holidays) {
      this.load = true

      // 登録処理(fetch -> put)で対応する
      try {
        const company = await this._getCompany()
        company.holidays = holidays

        await this._editCompany(company)

        this.$toasted.success(this.$t('データ登録完了メッセージ'))

        this.form.holidays = holidays
        this.$refs.companyCalendarModal.closeModal()
      } catch (e) {
        console.log(e)
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }

      this.load = false
    },
  },
  watch: {
    'form.zipcode': function(zipcode) {
      let _this = this.form
      if (_this.countryCode != 'JP' && _this.countryCode != 'TH') return
      if (this.isFormLoading) {
        this.isFormLoading = false
        return
      }
      if (_this.countryCode == 'TH') {
        for (let i = 0; i < thailand.length; i++) {
          if (thailand[i].zipcode == zipcode) {
            _this.prefCode = 'TH-' + thailand[i].province_code // 州コード
            _this.address1 = thailand[i].amphoe // 郡
            _this.address2 = thailand[i].district // 地区
            break
          }
        }
        return
      }
      try {
        // NOTE: html上で直接scriptを呼び出している
        // eslint-disable-next-line no-undef
        new YubinBango.Core(zipcode, function(addr) {
          _this.prefCode = addr.region_id ? 'JP-' + (addr.region_id < 10 ? '0' + addr.region_id : addr.region_id) : '' // 都道府県ID
          _this.address1 = addr.locality // 市区町村
          _this.address2 = addr.street // 町域
        })
      } catch (err) {
        // console.log(err)
      }
    },
    'form.isFullWorkTime': function(boolean) {
      if (boolean) {
        this.form.displayStartTime = '00:00'
        this.form.displayEndTime = '23:59'
      }
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
    options: {
      get() {
        return defaultOptions
      },
      set() {
        // Do nothing
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.btn {
  font-size: 1.4rem;
  width: 12rem;
  height: 38px;
}
input[type=number] {
  text-align: left;
}
.form-file {
  font-size: 1.4rem;
}
.form-img {
  img {
    width: 80px;
    height: 80px;
  }
}
.form-file-delete {
  font-size: 1.8rem;
}
.size_w{
  width: 160px;
}
::v-deep .bootstrap-datetimepicker-widget {
  table td {
    border:none;
  }
}
</style>
